import { useContext, useEffect, useState } from "react";
import * as yup from "yup";
import {
  Box,
  Button,
  Typography,
  Modal,
  TextField,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
  RadioGroup,
  Radio,
  Container,
} from "@mui/material";

import { AuthContext } from "../../../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { SnackAlertContext } from "../../../context/SnackAlertContext";
import IndustryEmployeeForm from "./IndustryEmployeeForm";

const EditEmployeeDetails = () => {
  const navigate = useNavigate();
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { id } = useParams();
  const { authToken, ezorder, decoded, role } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  // get ID
  const getIndustryEmployee = async () => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      const response = await ezorder.get(`/users/${id}`, data);
      setUserDetails(response.data.employee);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleEmployeeUpdate = async (values) => {
    try {
      setLoading(true);

      const response = await ezorder.put(`/users/${userDetails.id}`, values, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status == 200 || response.status == 201) {
        openSnackMessage("success", "User Updated");
        navigate("/employees");
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getIndustryEmployee();
  }, [id]);

  if (userDetails) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          Edit Employee Details
        </Typography>
        <Box sx={{ marginTop: "16px" }}>
          <IndustryEmployeeForm
            protectEmail={true}
            userDetails={userDetails}
            loading={loading}
            handleSubmit={handleEmployeeUpdate}
            onCancel={() => {
              navigate(`/employees/${id}`);
            }}
          />
        </Box>
      </Box>
    );
  }
};

export default EditEmployeeDetails;
